import { render, staticRenderFns } from "./section-text.vue?vue&type=template&id=0391ad7e&scoped=true"
import script from "./section-text.vue?vue&type=script&lang=js"
export * from "./section-text.vue?vue&type=script&lang=js"
import style0 from "./section-text.vue?vue&type=style&index=0&id=0391ad7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391ad7e",
  null
  
)

export default component.exports